import bnc from "bnc";
const block = new bnc('course-button');
const courseRouteTpl = (id:string | number) => `/#/course/${id}`;

export {
    block,
    courseRouteTpl
};
